export default __webpack_public_path__ + "static/media/how-it-work-thumb.cdc1ce90.png";